// extracted by mini-css-extract-plugin
module.exports = {"goal":"SectionGoal_goal__OhPR9","container":"SectionGoal_container__ltcqj","goal__image":"SectionGoal_goal__image__m_LP7","goal__paragraph":"SectionGoal_goal__paragraph__95eeA"};